export default __webpack_public_path__ + "static/media/uniphore-color.ada1aab3.svg";